export enum VDevType {
  Disk = 'DISK',
  Mirror = 'MIRROR',
  Spare = 'SPARE',
  Replacing = 'REPLACING',
}
